export const defaultMessages = {
    ERR_NETWORK: 'Unable to connect to the server. Please try again later.',
    404: 'Request URL Not found.',
    422: 'Invalid input. Please check and try again.',
    500: 'Internal Server error. Try again later.',
    401: 'Session expired. Please login again.',
    403: 'You are not authorized to perform this action.',
};

export const roleToPath = {
    "admin": "/admin/dashboard",
};

export const callTypeStyles = {
    nurse: { path: "nurse", bgColor: "bg-nurseStationDullClr", textColor: "text-nurseStationClr" },
    bathroom: { path: "bathroom", bgColor: "bg-redDullClr", textColor: "text-bathroomAttendedBClr" },
    bluecode: { path: "bluecode", bgColor: "bg-blueCodeDullClr", textColor: "text-blueCodeClr" },
    additionalhelp: { path: "additional_help", bgColor: "bg-purpleDullClr", textColor: "text-purpleClr" },
    dripsensor: { path: "dripsensor", bgColor: "bg-lightDripSensorClr", textColor: "text-dripSensorClr" },
    housekeeping: { path: "housekeeping", bgColor: "bg-housekeepingDullClr", textColor: "text-housekeepingClr" },
    default: { path: "bathroom", bgColor: "bg-redDullClr", textColor: "text-bathroomAttendedBClr" },
};

export const bedCallTypeStyles = {
    nurse: { path: "nurse", bgColor: "bg-nurseStationClr", textColor: "text-white" },
    bathroom: { path: "bathroom", bgColor: "bg-bathroomAttendedBClr", textColor: "text-white" },
    bluecode: { path: "bluecode", bgColor: "bg-blueCodeClr", textColor: "text-white" },
    additionalhelp: { path: "additional_help", bgColor: "bg-purpleClr", textColor: "text-white" },
    dripsensor: { path: "dripsensor", bgColor: "bg-dripSensorClr", textColor: "text-white" },
    housekeeping: { path: "housekeeping", bgColor: "bg-housekeepingClr", textColor: "text-white" },
    default: { path: "bathroom", bgColor: "bg-bathroomAttendedBClr", textColor: "text-white" },
};

export const bedCardBottomCallTypeStyles = {
    nurse: { path: "nurse", textColor: "text-nurseStationClr" },
    bathroom: { path: "bathroom", textColor: "text-bathroomAttendedBClr" },
    bluecode: { path: "bluecode", textColor: "text-blueCodeClr" },
    additionalhelp: { path: "additional_help", textColor: "text-purpleClr" },
    dripsensor: { path: "dripsensor", textColor: "text-redClr" },
    housekeeping: { path: "housekeeping", textColor: "text-housekeepingClr" },
    default: { path: "bathroom", textColor: "text-bathroomClr" },
};

export const roleStyles = {
    nurse: { path: "nurse", textColor: "text-nurseStationClr", label: 'Nurse' },
    nurse_manager: { path: "nurse", textColor: "text-nurseStationClr", label: 'Nurse Manager' },
    bluecodeteam: { path: "bluecode", textColor: "text-blueCodeClr", label: 'Code Blue Team' },
    bluecodeteam_manager: { path: "bluecode", textColor: "text-blueCodeClr", label: 'Code Blue Manager' },
    housekeeping_manager: { path: "housekeeping", textColor: "text-housekeepingClr", label: 'House Keeping Manager' },
    housekeeper: { path: "housekeeping", textColor: "text-housekeepingClr", label: 'House Keeper' },
}

export const labelMap = {
    nurse: "Nurse",
    additionalhelp: "Additional Help",
    bluecode: "Blue Code",
    housekeeping: "Housekeeping",
    dripsensor: "Drip Sensor",
    bathroom: "Bathroom",
};